// extracted by mini-css-extract-plugin
export default {"product":"CartItem_product__80IIW","container":"CartItem_container__qemQA","remove":"CartItem_remove__P813k","bottom":"CartItem_bottom__K4oud","btns":"CartItem_btns__xgFi-"};